import Popper from "@material-ui/core/Popper";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { cx } from "../utils";
import CcTextField from "./CcTextField";

// MUI poppers default to z-index 1300, which buries the options list under
// CcModal (z-index 1500) — lift every CcAutocomplete popup above modals.
const CcAutocompletePopper = (props) => (
  <Popper
    {...props}
    className={cx("cc-autocomplete-menu", props.className)}
    style={{ ...props.style, zIndex: 1600 }}
  />
);

const CcAutocomplete = ({
  options = [],
  label,
  placeholder,
  error,
  helperText,
  required,
  getOptionLabel,
  InputLabelProps,
  size = "md",
  inputClassName,
  className,
  ...props
}) => {
  const isSmall = size === "sm" || size === "small";

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      size={isSmall ? "small" : "medium"}
      className={cx("cc-autocomplete-control", className)}
      PopperComponent={CcAutocompletePopper}
      renderInput={(params) => (
        <CcTextField
          {...params}
          required={required}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          InputLabelProps={InputLabelProps}
          inputClassName={cx(isSmall && "cc-input--sm", inputClassName)}
        />
      )}
      {...props}
    />
  );
};

export default CcAutocomplete;
